import React from 'react'
import { Logo as _Logo } from './__styles__'

export default function Logo({ url }) {
    return (<_Logo src={url} />)
}
